module.exports = __webpack_public_path__ + "img/i_main_s_my_tv.e3c55b51.svg";